import React, { CSSProperties } from 'react';
import * as styles from './index.module.less';
import { LoadingImageUrl } from '@/constants';

interface IProps {
  media:
    | {
        type: 'image';
        src: string;
        alt: string;
        objectFit?: 'contain' | 'cover';
      }
    | {
        type: 'video';
        src: string;
        autoPlay?: boolean;
        loop?: boolean;
        muted?: boolean;
        objectFit?: 'contain' | 'cover';
      };
  ratio?: number;
  isLazyLoad?: boolean;
  className?: string;
  style?: CSSProperties;
  mediaClassName?: string;
  mediaStyle?: CSSProperties;
}

const RatioMedia = ({
  media,
  ratio = 3 / 4,
  isLazyLoad = false,
  className = '',
  style,
  mediaClassName = '',
  mediaStyle,
}: IProps) => {
  return (
    <div
      style={Object.assign(
        {
          paddingTop: `calc(100% * (${ratio}))`,
        },
        style,
      )}
      className={`${styles.wrapper} ${className}`}
    >
      {media.type === 'image' && (
        <img
          className={`${styles.image_media} ${isLazyLoad && 'lozad'} ${mediaClassName}`}
          style={Object.assign(
            {},
            mediaStyle,
            isLazyLoad
              ? {
                  objectFit: 'cover',
                }
              : {
                  objectFit: media.objectFit ?? 'fill',
                },
          )}
          data-src={media.src}
          data-object-fit={media.objectFit ?? 'fill'}
          src={isLazyLoad ? LoadingImageUrl : media.src}
          alt={media.alt}
        />
      )}
      {media.type === 'video' && (
        <video
          className={`${isLazyLoad && 'lozad'} ${mediaClassName}`}
          style={Object.assign(
            {
              position: 'absolute',
              height: '100%',
              width: '100%',
              top: '0',
              left: '0',
            },
            mediaStyle,
            isLazyLoad
              ? {
                  objectFit: 'cover',
                }
              : {
                  objectFit: media.objectFit ?? 'fill',
                },
          )}
          autoPlay={media.autoPlay || true}
          muted={media.muted || true}
          loop={media.loop || true}
          poster={isLazyLoad && LoadingImageUrl}
          data-object-fit={media.objectFit ?? 'fill'}
        >
          <source data-src={media.src} src={isLazyLoad ? LoadingImageUrl : media.src} type="video/mp4" />
        </video>
      )}
    </div>
  );
};
export default RatioMedia;
